<template>
  <div>
  <el-dialog title="添加排行榜" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" ref="form" :model="form">
      <el-form-item label="接口名称" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="name">
         <el-input v-model="form.name"  placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="排行榜主体字段名" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="rank_key">
         <el-input v-model="form.rank_key"  placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="排行榜数值字段名" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="rank_value">
         <el-input v-model="form.rank_value"  placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="接口地址" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="data_link">
         <el-input v-model="form.data_link"  placeholder="" class="max-w460"></el-input>
         <div>请输入http开头的接口地址</div>
      </el-form-item>
      <el-form-item label="页数字段名" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="page_name">
         <el-input v-model="form.page_name"  placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="每页数量字段名" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="limit_name">
         <el-input v-model="form.limit_name"  placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="备注信息" :label-width="formLabelWidth" >
         <el-input v-model="form.remark"  placeholder="" class="max-w460"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="add" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
  import RankingApi from '@/api/ranking.js';
  export default {
    components: {
    },
    data() {
      return {
        /*是否上传图片*/
        isupload: false,
        open_user: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        /*form表单数据*/
        user:{},
        form: {
          name: '',
          data_link:'',
          rank_key: '',
          rank_value: '',
          page_name: 'page',
          limit_name: 'list_rows',
          remark: '',
        },
      };
    },
    props: ['open_add'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {
        /*上传*/
      openUpload(e) {
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.form.image_url = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }
        this.isupload = false;
      },
      /*修改用户*/
      add() {
        let self = this;

        let params = self.form;
        console.log(params)
        
        
         self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
              RankingApi.sourceAdd(params, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，操作成功',
                    type: 'success'
                  });
                  self.dialogFormVisible(true);
                }
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
        
      },
      showMessage(msg='信息不能为空'){
        this.$message({
            message: msg,
            type: 'warning'
          });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*打开用户弹窗*/
      openUserDialog() {
        this.open_user = true;
      },
      /*关闭用户弹窗*/
      closeUserDialog(e) {
        if (e.type != 'error') {
          this.user = e.params[0];
          console.log(e.params[0])
          this.form.user_id = e.params[0].user_id;
        }
        this.open_user = false;
      },


    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/ranking/source/dialog/Add.vue